export default __webpack_public_path__ + "images/bd215cc9090630f5cf9cf95c7ebcd0e6-dinner.webp";